import React from "react";
import { useTourPageContext } from "../../_client/context";
import { TourHeroActivityLevel } from "./TourHeroActivityLevel";
import { TourHeroClassLevel } from "./TourHeroClassLevel";
import { TourHeroDetail } from "./TourHeroDetail";
import { TourHeroGroupSize } from "./TourHeroGroupSize";
import { TourHeroReviews } from "./TourHeroReviews";
import style from "./TourHeroSummaryInfo.module.scss";

enum HeroSummaryId {
    GROUP_SIZE = "groupSize",
    CLASS_LEVEL = "classLevel",
    REVIEWS = "reviews",
    ACTIVITY_LEVEL = "activityLevel",
    EQUIPMENT = "equipment",
}

export const TourHeroSummaryInfo: React.FC<
    React.PropsWithChildren<unknown>
> = () => {
    const { pageConfig, tourContent } = useTourPageContext();

    const customizedSectionOrder = pageConfig.heroSummaryOrder.map(
        (sectionBlok) => sectionBlok.section,
    );

    const sectionComponentMap = {
        [HeroSummaryId.GROUP_SIZE]: <TourHeroGroupSize />,
        [HeroSummaryId.CLASS_LEVEL]: <TourHeroClassLevel />,
        [HeroSummaryId.REVIEWS]: <TourHeroReviews />,
        [HeroSummaryId.ACTIVITY_LEVEL]: <TourHeroActivityLevel />,
        [HeroSummaryId.EQUIPMENT]: (
            <TourHeroDetail
                label={tourContent.equipmentSummary?.label}
                title={tourContent.equipmentSummary?.title}
                description={tourContent.equipmentSummary?.description}
            />
        ),
    };

    return (
        <div className={style["summary-info-wrapper"]}>
            {customizedSectionOrder.map((section) => (
                <React.Fragment key={section}>
                    {
                        sectionComponentMap[
                            section as keyof typeof sectionComponentMap
                        ]
                    }
                </React.Fragment>
            ))}
        </div>
    );
};
